import { render, staticRenderFns } from "./BiodigestorGeneralViewWidgetComponent.vue?vue&type=template&id=9edd5080&"
import script from "./BiodigestorGeneralViewWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./BiodigestorGeneralViewWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports